import type { FieldMetaProps, FormikContextType } from 'formik'

export function isInvalid(meta: FieldMetaProps<any>): boolean {
  return Boolean(meta.error) && meta.touched
}

export function isDisabled(context: FormikContextType<any>): boolean {
  return context.isSubmitting || !context.dirty || !context.isValid
}

export function isSubmitting(context: FormikContextType<any>): boolean {
  return context.isSubmitting
}
